/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Shield = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12 1C13.538 2.29045 14.8713 3.12378 16 3.5C17.1287 3.87622 18.7953 4.04289 21 4V11.5982C21 14.3756 19.7177 16.9973 17.5255 18.7024L12 23L6.47453 18.7024C4.28226 16.9973 3 14.3756 3 11.5982V4C5.32585 4.00249 6.99252 3.83583 8 3.5C9.00748 3.16417 10.3408 2.33084 12 1ZM11.984 2.908L11.9672 2.92147C10.6117 3.92823 9.45907 4.59478 8.47434 4.92303C7.55818 5.22841 6.2884 5.40569 4.63475 5.47102L4.5 5.475V11.5982C4.5 13.8162 5.48136 15.9152 7.17106 17.3368L7.39545 17.5184L11.999 21.099L16.6046 17.5184C18.3553 16.1567 19.4096 14.0934 19.4945 11.8868L19.5 11.5982V5.494L19.3592 5.49092C17.9199 5.4428 16.7308 5.2833 15.7793 5.00259L15.5257 4.92303C14.4568 4.56676 13.2935 3.90203 12.0159 2.93293L11.984 2.908Z"
                        fill={color}
                    />
                </svg>
        );
    };
